import TKCustomElementFactory from '@tk/utilities/tk.custom.element.factory';
import TKFilter from '@tk/components/tk.filter';

export default class TKFilterResult extends TKCustomElementFactory {
    removeAll?: HTMLButtonElement;
    tkFilter?: TKFilter;

    constructor() {
        super();

        this.removeAll = this.querySelector('[data-tk-filter-result-remove]') || undefined;
        this.tkFilter = this.closest('tk-filter') || undefined;
    }

    connectedCallback(): void {
        this.registerClickListener();
        this.registerFilterListener();
    }

    registerClickListener(): void {
        const handleRemoveAll = this.removeFilterItems.bind(this);
        this.pushListener({ event: 'click', element: this.removeAll!, action: handleRemoveAll });
    }

    registerFilterListener(): void {
        this.tkFilter?.subscribe((data) => {
            if (data.action === 'REFRESHED') {
                if (data.filterList.length === 0) this.remove();
            }
        });
    }

    removeFilterItems() {
        this.tkFilter?.deleteAll();
        this.tkFilter?.post();
    }
}
